import CrudPage from '@modules/cruds/CrudPage';
import DeliveryChainForm from './DeliveryChainForm';
import * as yup from 'yup'; // for everything
import { defaultConfigComponent } from './DeliveryChains';
import { CDeliveryChain } from '@ts/ui-models';
import { normalizeCDeliveryChain } from './normalizers/DeliveryChain.normalizer';

const DeliveryChainSchema = yup.object().shape({
  name: yup.string().required().label('Name'),
  channelId: yup.string().required().label('Channel'),
  parameters: yup
    .object()
    .nullable()
    .when('forwarderId', {
      is: 'mahvis',
      then: yup.object({
        defaultGNSSCoordinates: yup.object({
          x: yup
            .number()
            .required()
            .label('Longitude')
            //@ts-ignore
            .test('x', 'Longitude must be between -180 and 180', value => value && value >= -180 && value <= 180),
          y: yup
            .number()
            .required()
            .label('Latitude')
            //@ts-ignore
            .test('y', 'Latitude must be between -90 and 90', value => value >= -90 && value <= 90),
          z: yup.number().required().label('Z'),
        }),
      }),
    })
    .when('transporterId', {
      is: 'discoveryRTLSApp',
      then: yup.object({
        mainUniqueIdPrefix: yup.string().required().label('Tag ID prefix'),
        //Check format of sensorPlacementSettings (array of objects)
        sensorPlacementSettings: yup.array().of(
          yup.object({
            tagId: yup
              .string()
              .required()
              .label('Tag ID')
              .test(
                'tagId',
                'Tag ID must be 4 uppercase hex characters',
                //@ts-ignore
                value => value.length === 4 && value.match(/^[0-9A-F]*$/)
              ),
            detectionDistance: yup.number().required().label('Detection distance'),
            fixedTagHeight: yup.number().required().label('Fixed tag height'),
            tagOffsetVector: yup
              .array()
              .of(yup.number())
              .required()
              .label('Tag offset vector')
              .test('tagOffsetVector', 'Tag offset vector must be of length 2', value => value?.length === 2),
          })
        ),
      }),
    }),
});

const DeliveryChainPage = () => {
  return (
    <CrudPage
      key={'deliveryChainPage'}
      configComponent={defaultConfigComponent}
      form={DeliveryChainForm}
      validationSchema={DeliveryChainSchema}
      defaultValues={new CDeliveryChain()}
      normalize={normalizeCDeliveryChain}
    />
  );
};

export default DeliveryChainPage;
